import initialData from "./initialData.json";

export const getInitialData = () => {
  return initialData;
};

export const getStoredData = (key) => {
  const storedData = localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : null;
};

export const setStoredData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getMergedData = (key) => {
  const storedData = localStorage.getItem(key);
  return storedData ? JSON.parse(storedData) : initialData[key];
};

export const updateStoredData = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};
